module.exports = __webpack_public_path__ + "img/engineer.534a31fb.png";